import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class CourseRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    return true;
  }
}